export enum SlideDirection {
    Left = "left",
    Right = "right",
}